import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import {
  customerContainer,
  accountsContainer,
  storeContainer,
} from 'src/models'
import { IoIosArrowBack as BackIcon } from 'react-icons/io'
import { toastState } from 'src/views/components'
import {
  getIroncladAcceptanceData,
  getMemberGroupKey,
  loadClickWrapContainer,
  parsePhoneNumberField,
  retrieveAccountTypeGroupKey,
  toggleIronCladCheck,
} from 'src/utils/signUpUtils'
import { Button, Row, Col, Card, Form } from 'react-bootstrap'
import { getLocaleCodeFromUrl, i18nTranslate, IS_BROWSER } from 'src/utils'
import {
  application,
  getLocalStorage,
  isB2B2CAdmin,
  filterWhiteLabelEmails,
  getParsedPhoneNumber,
} from 'src/utils'
import { countryData } from 'src/views/components/SignUpForms/countryCodeData'
import './styles.scss'
import { accountTypeTranslation } from 'src/deps/MyAccountInfoDeps'
import ConversionDisclaimerPopup from 'src/views/components/BAConversionModal/ConversionDisclaimerPopup'
import { trackGTMEvents } from 'src/utils'
import AccountConvertedSuccessPopup from 'src/views/components/BAConversionModal/AccountConvertedSuccessPopup'
import AccountConvertedFailPopup from 'src/views/components/BAConversionModal/AccountConvertedFailPopup'
import { APPConfig, consentIpAddress } from 'config/appConfig'
import tokenExIframe from 'src/views/components/TokenExIframe'

@observer
class DownConvertAccountType extends React.Component {
  @observable AddressFormRef = React.createRef()
  @observable show = false
  @observable isPrivacy1Checked = false
  @observable isPrivacy2Checked = false
  @observable show = false
  @observable showConversionDisclaimerModal = false
  @observable showAccountConvertedSuccessModal = false
  @observable showAccountConvertedFailModal = false
  @observable isAccountStatus = false
  @observable isResponseLoading = false
  @observable maxAttemptsReached = false
  @observable hideCancelButton = false
  @observable hideCancelButton = false
  @observable checkAccountConversionApiStatus = false
  @observable errorMessage = ''
  @observable profileDataVal = []
  @observable setCheckPhoneVal = {}
  @observable convertAccountType = 'Preferred Customer/Member'

  FORM = 'FORM'
  POPUP = 'POPUP'
  SUBMIT_BUTTON = 'SUBMIT_BUTTON'

  constructor(props) {
    super(props)
    loadClickWrapContainer()
    accountsContainer.signUpIronCladCheck.clickWrap1 = false
    accountsContainer.signUpIronCladCheck.clickWrap2 = false
  }

  async componentDidMount() {
    this.getSponsorAffiliateName()
    this.profileData()
    this.siteObjectBasedonConvertAccountType(this.convertToMember)
    this.isPsContractChecked()
    this.isPrivacy1Checked =
      accountsContainer.signUpIronCladCheck?.clickWrap1 || false
    this.isPrivacy2Checked =
      accountsContainer.signUpIronCladCheck?.clickWrap2 || false
  }
  componentDidUpdate() {
    this.isPrivacy1Checked =
      accountsContainer.signUpIronCladCheck?.clickWrap1 || false
    this.isPrivacy2Checked =
      accountsContainer.signUpIronCladCheck?.clickWrap2 || false
  }

  isPsContractChecked() {
    accountsContainer.convertAccoutType = this.convertAccountType
    if (_ps) {
      _ps.on('checked', element => {
        this.ironCladCheckedString = toggleIronCladCheck(true, element)
      })
      _ps.on('unchecked', element => {
        this.ironCladCheckedString = toggleIronCladCheck(false, element)
      })
    }
  }
  siteObjectBasedonConvertAccountType = () => {
    const groupKey = retrieveAccountTypeGroupKey(this.convertAccountType) || ''
    getMemberGroupKey(groupKey)
  }
  getSponsorAffiliateName = customerContainer => {
    return `${customerContainer?.sponsorName?.firstName || ''} ${
      customerContainer?.sponsorName?.lastName || ''
    }`.trim()
  }
  handleSaveChanges = async () => {
    toastState.setToastMessage(
      i18nTranslate(
        'account.successMessage',
        'Your account has successfully been changed to Member.'
      ),
      true,
      '',
      '',
      false,
      false,
      i18nTranslate(
        'account.successDescription',
        'You will now be signed out. Please sign back in to see your changes.'
      )
    )
  }

  handleSignOutClick = async () => {
    const activeLocale = getLocaleCodeFromUrl({
      defaultLocale: 'en_US',
      isReverseType: true,
    })
    const localeInUrl = activeLocale?.toLowerCase()?.split('_')
    const currentUrlLocale = `${localeInUrl[1]}/${localeInUrl[0]}`
    await customerContainer.logout()
    // reloading page hence intiate the applicaton
    if (IS_BROWSER) {
      window.location.reload()
      const newUrl = `${window.location.origin}/${currentUrlLocale}`
      window.location.href = newUrl
    }
  }

  handleConversionDisclaimerPopup = () => {
    this.showConversionDisclaimerModal = true
    this.hideCancelButton = true
    trackGTMEvents({
      event: 'account switch',
      account_type: 'BA to Member',
      privacy_policy: this.isPrivacy1Checked ? 'yes' : 'no',
      agreement: this.isPrivacy2Checked ? 'yes' : 'no',
      platform: 'equinox',
    })
  }

  handleConversionDisclaimerPopupClose = () => {
    this.showConversionDisclaimerModal = false
    this.hideCancelButton = false
    trackGTMEvents({
      event: 'final account cancel',
      account_type: 'BA to Member',
      platform: 'equinox',
    })
  }

  handleShowAccountConvertedSuccessModalClose = () => {
    this.showConversionDisclaimerModal = false
    this.showAccountConvertedSuccessModal = false
    this.handleSignOutClick()
  }
  handleShowAccountConvertedFailModalClose = () => {
    this.showConversionDisclaimerModal = false
    this.showAccountConvertedFailModal = false
  }
  handleAcceptanceData = async () => {
    const signUpConsents = []
    const groupKey = retrieveAccountTypeGroupKey(this.convertAccountType) || ''
    const groupKeys = {
      checkbox1: retrieveAccountTypeGroupKey(this.convertAccountType) || '',
      checkbox2: retrieveAccountTypeGroupKey(this.convertAccountType) || '',
    }
    const acceptanceResponses = await Promise.all([
      getIroncladAcceptanceData(groupKeys.checkbox1),
      getIroncladAcceptanceData(groupKeys.checkbox2),
    ])
    const [checkbox1Response, checkbox2Response] = acceptanceResponses

    const otherInfo = {
      ipAddress: consentIpAddress,
      geoLocation:
        storeContainer.currentRegion || getLocalStorage('currentRegion') || '',
      browser: 'chrome',
      device: 'mobile',
    }
    const acceptanceInfoPage1 = {
      ...otherInfo,
      title: 'contracts_ironclad_page1',
      acceptanceData: checkbox1Response || [],
    }

    const acceptanceInfoPage2 = {
      ...otherInfo,
      title: 'contracts_ironclad_page2',
      acceptanceData: checkbox2Response || [],
    }
    signUpConsents.push(acceptanceInfoPage1, acceptanceInfoPage2)
    return signUpConsents
  }
  handleDoConversion = async () => {
    this.showConversionDisclaimerModal = false
    this.isResponseLoading = true
    const sponsorId = accountsContainer?.getUserTypeSponsorId()
    const accountId =
      customerContainer?.profileResponse?.accounts?.referenceAttribute || ''
    const email = customerContainer?.profileResponse?.email || ''
    const phoneNumber = customerContainer?.profileResponse?.phoneNumber || ''
    const firstName = customerContainer?.profileResponse?.firstName || ''
    const lastName = customerContainer?.profileResponse?.lastName || ''
    const businessType =
      customerContainer?.profileResponse?.accounts?.accountType || ''
    let localValue = getLocaleCodeFromUrl() || ''
    const accountDetails = {
      accountId: accountId,
      businessType: businessType,
      classification: 'Preferred',
      sponsorId: sponsorId,
      email: email,
      phone: phoneNumber,
      firstName: firstName,
      lastName: lastName,
      locale: localValue,
    }
    accountDetails.consents = (await this.handleAcceptanceData()) || {}
    const response =
      await accountsContainer?.postAccountConversion(accountDetails)
    if (accountsContainer.isSuccessResponse(response)) {
      this.checkConversionStatus(accountId)
    } else {
      this.checkAccountConversionApiStatus = true
      this.showAccountConvertedFailModal = true
      this.isResponseLoading = false
    }
    trackGTMEvents({
      event: 'final account confirmation',
      account_type: 'BA to Member',
      platform: 'equinox',
    })
  }

  checkConversionStatus = async accountId => {
    const waitTime = APPConfig?.getAppConfig()?.accountConversionWaitTime
    const interval = APPConfig?.getAppConfig()?.accountConversionFrequency
    const maxAttempts = waitTime / interval
    let attempts = 0
    const intervalId = setInterval(async () => {
      if (attempts >= maxAttempts) {
        clearInterval(intervalId)
        this.maxAttemptsReached = true
        this.isResponseLoading = true
        return
      }
      attempts++
      const response = await accountsContainer.getConversionStatus(accountId)
      if (accountsContainer.isSuccessResponse(response)) {
        if (
          accountsContainer.isSuccessResponse(response) &&
          response?.responseStatus === 'success'
        ) {
          this.isResponseLoading = false
          this.showAccountConvertedSuccessModal = true
          clearInterval(intervalId)
        } else if (
          accountsContainer.isSuccessResponse(response) &&
          response?.responseStatus === 'failure'
        ) {
          this.isResponseLoading = false
          this.showAccountConvertedFailModal = true
          clearInterval(intervalId)
        } else if (
          accountsContainer.isSuccessResponse(response) &&
          response?.responseStatus === 'inProgress'
        ) {
          this.isResponseLoading = true
        }
      } else {
        this.checkAccountConversionApiStatus = true
        this.showAccountConvertedFailModal = true
        this.isResponseLoading = false
      }
    }, interval)
  }

  handleBack = () => {
    this.props?.handleShowDownConvertForm(false)
    trackGTMEvents({
      event: 'account switch cancel',
      account_type: 'BA to Member',
      privacy_policy: this.isPrivacy1Checked ? 'yes' : 'no',
      agreement: this.isPrivacy2Checked ? 'yes' : 'no',
      platform: 'equinox',
    })
  }

  getStyleGuides(dataKey) {
    switch (dataKey) {
      case this.SUBMIT_BUTTON:
        let homeCountry = storeContainer.currentRegion || ''

        customerContainer?.profileResponse?.accounts?.properties?.forEach(
          (element = {}) => {
            if (element.attributeId === 'countryCode') {
              homeCountry = element.value
            }
          }
        )

        if (homeCountry === 'CA') {
          homeCountry = 'Canada'
        }

        let hideMessage = ''
        if (!isB2B2CAdmin()) {
          hideMessage = 'd-none'
        } else {
          hideMessage =
            homeCountry === storeContainer.storeIDValue ? '' : 'd-none'
        }

        return {
          hideMessageClass: hideMessage,
          showMessageClass:
            homeCountry === storeContainer.storeIDValue
              ? 'd-none'
              : 'non-home-market-country mt-1',
          size: application.isMobile ? 'sm' : 'md',
        }

      default:
        return {}
    }
  }

  renderSubmitButton = () => {
    const styles = this.getStyleGuides(this.SUBMIT_BUTTON)

    return (
      <Row>
        <Col md={6} lg={6} className={`${styles?.hideMessageClass} text-left`}>
          <Button
            variant="primary"
            className={`addressbook-add-button mt-2 w-100 rounded ${
              this.isResponseLoading
                ? 'd-flex justify-content-between align-items-center'
                : ''
            }`}
            data-testid="qa-save-changes"
            size={styles?.size}
            disabled={
              !(
                accountsContainer.signUpIronCladCheck?.clickWrap1 &&
                accountsContainer.signUpIronCladCheck?.clickWrap2
              )
            }
            type="submit"
            onClick={
              !this.isResponseLoading
                ? this.handleConversionDisclaimerPopup
                : null
            }>
            {this.isResponseLoading ? (
              <>
                <div className="d-flex flex-column align-items-center flex-grow-1">
                  <div className="ml-2">
                    {i18nTranslate(
                      'ba_to_member_check_account_status',
                      'Checking account status…'
                    )}
                  </div>
                  {this.maxAttemptsReached ? (
                    <div className="ml-2 account-status-description">
                      {i18nTranslate(
                        'ba_to_member_experiencing_longer_load_time',
                        'Looks like we’re experiencing longer load times than expected.'
                      )}
                    </div>
                  ) : (
                    <div className="ml-2 account-status-description">
                      {i18nTranslate(
                        'ba_to_member_check_account_status_time',
                        'This could take a couple of minutes'
                      )}
                    </div>
                  )}
                </div>
                {!this.maxAttemptsReached && (
                  <div
                    className="ml-2 spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"></div>
                )}
              </>
            ) : (
              i18nTranslate(
                'ba_to_member_account_switch_to_member_account',
                'Continue with Switch to Member Account'
              )
            )}
          </Button>
          {!this.hideCancelButton && (
            <Button
              className="acknowledge-button rounded-md"
              variant="outline-primary"
              data-testid="qa-exit-cancel-button"
              block
              onClick={this.handleBack}
              tabIndex={0}>
              {i18nTranslate('cancelOrderForm.cancel', 'Cancel')}
            </Button>
          )}
          {this.maxAttemptsReached && (
            <div className="small mt-2">
              {i18nTranslate(
                'ba_to_member_email_notification',
                'We’ll send you an email notification with more info when this is ready.'
              )}
            </div>
          )}
        </Col>
      </Row>
    )
  }

  async getProfileFormData(profileResponse = {}) {
    const { phoneNumber = '' } = profileResponse
    if (phoneNumber != '') {
      const parsedPhoneNumber = await getParsedPhoneNumber(phoneNumber)

      const phone = parsedPhoneNumber?.phoneNumberCode
      const phoneCountry = parsedPhoneNumber?.phoneCountry

      Object.keys(profileResponse).forEach(item => {
        if (
          item === 'phoneNumber' &&
          typeof profileResponse[item] !== undefined
        ) {
          profileResponse['parsedPhoneNumber'] = phone
        }
      })

      profileResponse['phoneCountry'] = phoneCountry || ''
    }

    return profileResponse
  }

  setProfileData = async () => {
    const accountPrefillData = {
      accountInfo: accountsContainer?.profileResponse,
    }

    const acctype1 = getLocalStorage('accountType')
    const isBusinessEntity = acctype1 === 'Brand Affiliate - Business Entity'

    const identity =
      (await this.getProfileFormData(customerContainer?.profileResponse)) || {}

    const identityExist = identity?.accounts

    const {
      lastName = '',
      phoneNumber = '',
      email = '',
      phoneCountry = '',
      parsedPhoneNumber = '',
    } = identity || {}

    const email2 = identityExist ? getLocalStorage('admnEmail') : ''
    const phoneNumber2 = identityExist ? getLocalStorage('admnPhoneNumber') : ''
    const firstName = isBusinessEntity
      ? identityExist
        ? name
        : ''
      : identity?.firstName
    const accountIdentity = await this.getProfileFormData({
      phoneNumber: accountPrefillData?.accountInfo?.phoneNumber || '',
    })
    const accountPhone = isBusinessEntity
      ? accountIdentity?.parsedPhoneNumber || ''
      : parsedPhoneNumber
    const accountEmail = isBusinessEntity
      ? accountPrefillData?.accountInfo?.properties?.[0]?.value || ''
      : email
    const parsedPhoneCountry = isBusinessEntity
      ? accountIdentity?.phoneCountry
      : phoneCountry

    // Start of parse phone number code
    let userCountry = ''
    customerContainer?.profileResponse?.accounts?.properties?.forEach(
      element => {
        if (element.attributeId === 'countryCode') {
          userCountry = element.value
        }
      }
    )
    const localCountry =
      userCountry ||
      (storeContainer?.storeIDValue === 'Canada'
        ? 'CA'
        : storeContainer?.storeIDValue)
    let inputCode = countryData()?.find(
      element => element.value === localCountry
    )?.value
    let phoneNumberCode = accountPhone

    if (accountPhone) {
      inputCode = parsedPhoneCountry || inputCode
    }
    const phoneNumberCodeVal = await parsePhoneNumberField(
      phoneNumberCode,
      inputCode
    )
    const phoneCode = phoneNumberCodeVal?.countryCallingCode
      ? '+' + phoneNumberCodeVal?.countryCallingCode
      : ''
    this.profileDataVal = [
      {
        label: i18nTranslate('profileData.name', 'Name'),
        value: isBusinessEntity ? firstName : `${firstName} ${lastName}`,
        dataTestId: 'qa-account-name',
      },
      {
        label: i18nTranslate('profileData.email', 'Email'),
        value: filterWhiteLabelEmails({
          email: !isB2B2CAdmin() ? email2 : accountEmail,
        }),
        dataTestId: 'qa-account-email',
      },
      {
        label: i18nTranslate('profileData.phoneNumber', 'Phone Number'),
        phoneCountry: inputCode,
        value: !isB2B2CAdmin()
          ? phoneNumber2
          : phoneCode && phoneNumberCode
            ? `${phoneCode} ${phoneNumberCode}`
            : '',
        dataTestId: 'qa-account-phone-number',
      },
    ]
  }

  profileData = async () => {
    if (Object.keys(customerContainer?.profileResponse)?.length > 0) {
      if (Object.keys(accountsContainer?.profileResponse)?.length > 0) {
        this.setProfileData()
      } else {
        setTimeout(() => {
          this.profileData()
        }, 100)
      }
    } else {
      setTimeout(() => {
        this.profileData()
      }, 100)
    }
  }

  AccountTypeForm = () => {
    const accountType =
      customerContainer?.profileResponse?.accounts?.accountType ===
      'Brand Affiliate'
        ? 'Preferred Customer/Member'
        : ''
    return {
      name: 'changeAccountTypeName',
      translatedAriaLabel: 'aria-label',
      type: 'text',
      columnType: {
        lg: '6',
      },
      maxLength: 50,
      defaultValue: accountTypeTranslation(accountType) || '',
      disabled: true,
      required: true,
      dataTestId: 'qa-account-type-text',
    }
  }

  handlePrivacy1Checkbox = event => {
    this.isPrivacy1Checked = event?.target?.checked
  }

  handlePrivacy2Checkbox = event => {
    this.isPrivacy2Checked = event?.target?.checked
  }

  checkboxConfigs = () => {
    return [
      {
        id: 'privacy-checkbox-1',
        type: 'checkbox',
        label: (
          <div className="event-submit-terms-checkbox mb-3">
            {i18nTranslate(
              'nuskinEnjoyRewards.terms',
              'I have read, understand and agree to the '
            )}{' '}
            <a
              href="https://vault.pactsafe.io/s/1afda702-5218-40d2-a5e0-95da5e891fa8/legal.html?g=44830#contract-rzeaxqogz"
              target="_blank"
              rel="noopener noreferrer"
              className="event-submit-tc-link">
              {i18nTranslate(
                'account.usRefundPolicy',
                'US Refund Policy'
              ).replace(/[.。]/g, '')}
            </a>
            {', '}
            <a
              href="https://vault.pactsafe.io/s/1afda702-5218-40d2-a5e0-95da5e891fa8/legal.html?g=44830#contract-zo1edxrwb"
              target="_blank"
              rel="noopener noreferrer"
              className="event-submit-tc-link">
              {i18nTranslate('account.usTermsOfUse', 'US Terms of Use')}
            </a>
            {', '}
            {i18nTranslate('signup.ironcladConjunction', 'and')}{' '}
            <a
              href="https://vault.pactsafe.io/s/1afda702-5218-40d2-a5e0-95da5e891fa8/legal.html?g=44830#contract-rpwelzmav"
              target="_blank"
              rel="noopener noreferrer"
              className="event-submit-tc-link">
              {i18nTranslate(
                'account.globalPrivacyNotice',
                'Global Privacy Notice'
              )}
              .
            </a>
          </div>
        ),
        onValueChange: event => {
          this.handlePrivacy1Checkbox(event)
        },
      },
      {
        id: 'privacy-checkbox-2',
        type: 'checkbox',
        label: (
          <div className="event-submit-terms-checkbox mb-3">
            {i18nTranslate('ba_to_member_i_agree_to', 'I agree to the')}{' '}
            <a
              href="https://vault.pactsafe.io/s/1afda702-5218-40d2-a5e0-95da5e891fa8/legal.html?g=44829#contract-ung1zznbr"
              target="_blank"
              rel="noopener noreferrer"
              className="event-submit-tc-link">
              {i18nTranslate(
                'account.usMemberAgreement',
                'US Member Agreement.'
              ).replace(/[.。]/g, '')}
            </a>
            {', '}
          </div>
        ),
        onValueChange: event => {
          this.handlePrivacy2Checkbox(event)
        },
      },
    ]
  }

  renderProfileInfo = () => {
    const accountCardForm = this.AccountTypeForm()
    const checkBox = this.checkboxConfigs()
    return (
      <Card
        className={`accountProfileInfoCont mb-3 shadow-sm`}
        data-testid={'qa-accountProfile-container'}>
        <div>
          <Button
            aria-label={i18nTranslate('loyaltydasboard.back', 'Back')}
            className="downConvertAccountBackButton"
            onClick={() => this.handleBack()}>
            <BackIcon />
            <span className="back-label pl-1">
              {i18nTranslate('loyaltydasboard.back', 'Back')}
            </span>
          </Button>
        </div>
        <Card.Body className="bg-white">
          <h1 className="card-title heading-2-bold card-title h5">
            {i18nTranslate(
              'ba_to_member_switch_to_preferred_customer_member',
              'Switch to Preferred Customer/Member'
            )}
          </h1>
          <Row className="mb-3">
            <Col md={6} lg={6}>
              <Form.Label
                htmlFor={accountCardForm?.dataTestId}
                aria-label={accountCardForm?.translatedAriaLabel}>
                <span className={`profileDataLabel font-weight-bold`}>
                  {i18nTranslate('accounts.accountTypeHeading', 'Account Type')}
                </span>
              </Form.Label>
              <Form.Control {...accountCardForm} />
            </Col>
          </Row>
          <div className="d-flex">
            <div className={`profileDataLabel font-weight-bold`}>
              {i18nTranslate(
                'sponsorChange.affiliateName',
                'Sponsoring Affiliate Name'
              )}
            </div>
          </div>
          <div className="d-flex mb-4">
            <div className="profileDataVal mt-2">
              {this?.getSponsorAffiliateName(customerContainer)}
            </div>
          </div>
          <h1
            data-testid={'qa-accountProfile-heading'}
            className="card-title heading-2-bold card-title h5 mt-6">
            {i18nTranslate(
              'sponsorChange.personalinfo',
              'Personal Information'
            )}
          </h1>
          {this.profileDataVal?.length > 0 &&
            this.profileDataVal?.map((item, index) => {
              if (!item?.value || item?.value === 'undefined') {
                return <></>
              }
              return (
                <Row key={index} className="mb-3">
                  <Col xs={12} className="">
                    <div className="d-flex">
                      <div
                        className={`profileDataLabel ${item?.label} font-weight-bold`}>
                        {item?.label}
                      </div>
                    </div>
                    <div className="d-flex">
                      <div
                        className="profileDataVal"
                        data-testid={item?.dataTestId ? item?.dataTestId : ''}>
                        {item?.value}
                      </div>
                    </div>
                  </Col>
                </Row>
              )
            })}
          <div className={`profileDataLabel font-weight-bold mb-3 mt-4`}>
            {i18nTranslate(
              'ba_to_member_privacy_notice_term',
              'Privacy Notice and Terms'
            )}
          </div>
          {tokenExIframe.clickwrapContainer()}
          {this.renderSubmitButton()}
        </Card.Body>
      </Card>
    )
  }
  render() {
    return (
      <React.Fragment>
        {this.showConversionDisclaimerModal && (
          <ConversionDisclaimerPopup
            showModal={this.showConversionDisclaimerModal}
            handleConversionDisclaimerPopup={
              this.handleConversionDisclaimerPopup
            }
            handleConversionDisclaimerPopupClose={
              this.handleConversionDisclaimerPopupClose
            }
            handleShowAccountConvertedSuccessModal={this.handleDoConversion}
          />
        )}
        {this.showAccountConvertedSuccessModal && (
          <AccountConvertedSuccessPopup
            showModal={this.showConversionDisclaimerModal}
            handleShowAccountConvertedSuccessModalClose={
              this.handleShowAccountConvertedSuccessModalClose
            }
          />
        )}
        {this.showAccountConvertedFailModal && (
          <AccountConvertedFailPopup
            checkAccountConversionApiStatus={
              this.checkAccountConversionApiStatus
            }
            showModal={this.showConversionDisclaimerModal}
            handleShowAccountConvertedFailModalClose={
              this.handleShowAccountConvertedFailModalClose
            }
          />
        )}
        {this.renderProfileInfo()}
      </React.Fragment>
    )
  }
}
export { DownConvertAccountType }
export default DownConvertAccountType
